<template>
  <v-group v-if="object" :config="{ x: object.tempDots[object.dot_index].x, y: object.tempDots[object.dot_index].y }">
    <v-label
      v-if="this.object.tempDots.length > 3"
      @click="removeNode()"
      @mouseenter="changeCursor('pointer')"
      @mouseleave="changeCursor('default')"
      :config="{ opacity: 0.75, fill: 'white' }"
    >
      <v-tag
        :config="{
          fill: 'black',
          pointerDirection: 'down',
          pointerWidth: 10,
          pointerHeight: 10,
          lineJoin: 'round',
          shadowColor: 'red',
          shadowBlur: 10,
          shadowOffset: 10,
          shadowOpacity: 0.5,
        }"
      ></v-tag
      ><v-text
        :config="{
          text: 'Удалить узел',
          fontFamily: 'Calibri',
          fontSize: 18,
          padding: 5,
          fill: 'white',
        }"
      ></v-text>
    </v-label>
    <v-label
      @click="addNode()"
      @mouseenter="changeCursor('pointer')"
      @mouseleave="changeCursor('default')"
      :config="{ opacity: 0.75, fill: 'white' }"
    >
      <v-tag
        :config="{
          fill: 'black',
          pointerDirection: 'up',
          pointerWidth: 10,
          pointerHeight: 10,
          lineJoin: 'round',
          shadowColor: 'green',
          shadowBlur: 10,
          shadowOffset: 10,
          shadowOpacity: 0.5,
        }"
      ></v-tag
      ><v-text
        :config="{
          text: 'Добавить узел',
          fontFamily: 'Calibri',
          fontSize: 18,
          padding: 5,
          fill: 'white',
        }"
      ></v-text>
    </v-label>

    <v-label
      v-if="pipeline && !object.tempDots[object.dot_index].dots"
      @click="addBranch()"
      @mouseenter="changeCursor('pointer')"
      @mouseleave="changeCursor('default')"
      :config="{ opacity: 0.75, fill: 'white' }"
    >
      <v-tag
        :config="{
          fill: 'black',
          pointerDirection: 'left',
          pointerWidth: 10,
          pointerHeight: 10,
          lineJoin: 'round',
          shadowColor: 'yellow',
          shadowBlur: 10,
          shadowOffset: 10,
          shadowOpacity: 0.5,
        }"
      ></v-tag
      ><v-text
        :config="{
          text: 'Добавить ответвление',
          fontFamily: 'Calibri',
          fontSize: 18,
          padding: 5,
          fill: 'white',
        }"
      ></v-text>
    </v-label>
    <v-label
      v-else-if="pipeline"
      @click="removeBranch()"
      @mouseenter="changeCursor('pointer')"
      @mouseleave="changeCursor('default')"
      :config="{ opacity: 0.75, fill: 'white' }"
    >
      <v-tag
        :config="{
          fill: 'black',
          pointerDirection: 'left',
          pointerWidth: 10,
          pointerHeight: 10,
          lineJoin: 'round',
          shadowColor: 'red',
          shadowBlur: 10,
          shadowOffset: 10,
          shadowOpacity: 0.5,
        }"
      ></v-tag
      ><v-text
        :config="{
          text: 'Удалить ответвление',
          fontFamily: 'Calibri',
          fontSize: 18,
          padding: 5,
          fill: 'white',
        }"
      ></v-text>
    </v-label>
    <v-label
      v-if="pipeline && !object.tempDots[object.dot_index].valve"
      @click="showValveWindow()"
      @mouseenter="changeCursor('pointer')"
      @mouseleave="changeCursor('default')"
      :config="{ opacity: 0.75, fill: 'white' }"
    >
      <v-tag
        :config="{
          fill: 'black',
          pointerDirection: 'right',
          pointerWidth: 10,
          pointerHeight: 10,
          lineJoin: 'round',
          shadowColor: 'yellow',
          shadowBlur: 10,
          shadowOffset: 10,
          shadowOpacity: 0.5,
        }"
      ></v-tag
      ><v-text
        :config="{
          text: 'Добавить задвижку',
          fontFamily: 'Calibri',
          fontSize: 18,
          padding: 5,
          fill: 'white',
        }"
      ></v-text>
    </v-label>
    <v-label
      v-if="pipeline && object.tempDots[object.dot_index].valve"
      @click="showValveWindow()"
      @mouseenter="changeCursor('pointer')"
      @mouseleave="changeCursor('default')"
      :config="{ opacity: 0.75, fill: 'white' }"
    >
      <v-tag
        :config="{
          fill: 'black',
          pointerDirection: 'right',
          pointerWidth: 10,
          pointerHeight: 10,
          lineJoin: 'round',
          shadowColor: 'yellow',
          shadowBlur: 10,
          shadowOffset: 10,
          shadowOpacity: 0.5,
        }"
      ></v-tag
      ><v-text
        :config="{
          text: 'Изменить задвижку',
          fontFamily: 'Calibri',
          fontSize: 18,
          padding: 5,
          fill: 'white',
        }"
      ></v-text>
    </v-label>
    <b-modal hide-footer ref="valve" title="Задвижка">
      <center>
        <b-row class="my-1">
          <b-col sm="6">
            <label for="hours">Название:</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="hours" v-model="valve.name" type="text"></b-form-input>
            <div class="text-danger" v-if="valve && valve.errors">{{ valve.errors[0] }}</div>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label for="hours">Аварийное отключение, с:</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="hours" v-model="valve.shutdown" type="number"></b-form-input>
            <div class="text-danger" v-if="valve && valve.errors">{{ valve.errors[0] }}</div>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label for="hours">Длина следующего участка, м:</label>
          </b-col>
          <b-col sm="3">
            <b-form-input id="hours" :disabled="valve.autoL" v-model="valve.L" type="number"></b-form-input>
            <div class="text-danger" v-if="valve && valve.errors">{{ valve.errors[0] }}</div>
          </b-col>
          <b-col sm="3"> <b-form-checkbox id="autoL" v-model="valve.autoL"></b-form-checkbox> Авто-расчёт </b-col>
        </b-row>
        <b-row class="my-1" v-if="object.obj_type == 44 || object.obj_type == 45 || object.obj_type == 46">
          <b-col sm="6">
            <label for="hours">Длина следующего опасного участка, м:</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="hours" v-model="valve.dangerousPart" type="number"></b-form-input>
            <div class="text-danger" v-if="valve && valve.errors">{{ valve.errors[0] }}</div>
          </b-col>
        </b-row>
        <b-btn v-if="object.tempDots[this.object.dot_index].valve" class="m-1" @click="removeValve()" variant="danger"
          >Удалить</b-btn
        ><b-btn v-if="valve" class="m-1" variant="success" @click.prevent="saveValve()">Сохранить</b-btn>
      </center>
    </b-modal>
  </v-group>
</template>

<script>
export default {
  props: {
    object: Object,
    pipeline: Boolean,
  },
  created() {},
  data() {
    return {
      show: false,
      valve: { shutdown: 360, name: "Задвижка", L: 1, dangerousPart: 0, autoL: true },
    };
  },
  methods: {
    removeNode() {
      this.$set(this.object.tempDots[this.object.dot_index], "deleted", true);
      this.$set(this.object, "edit", false);
      this.$set(this.object, "show", false);
      this.$emit("changeCursor", "default");
      this.$emit("save", this.object);
      this.show = false;
    },
    addNode() {
      this.object.tempDots.splice(this.object.dot_index + 1, 0, {
        x: this.object.tempDots[this.object.dot_index].x + 30,
        y: this.object.tempDots[this.object.dot_index].y + 30,
      });
      this.$set(this.object, "show", false);
      this.$emit("changeCursor", "default");
      this.$emit("save", this.object);
      this.show = false;
    },
    showValveWindow() {
      if (this.object.tempDots[this.object.dot_index].valve) {
        this.valve = this.object.tempDots[this.object.dot_index].valve;
      }
      this.$refs.valve.show();
    },
    saveValve() {
      this.$set(this.object.tempDots[this.object.dot_index], "valve", this.valve);
      this.$refs.valve.hide();
      this.$set(this.object, "show", false);
      this.$emit("changeCursor", "default");
      this.$emit("save", this.object);
      this.show = false;
    },
    removeValve() {
      delete this.object.tempDots[this.object.dot_index].valve;
      this.$refs.valve.hide();
      this.$set(this.object, "show", false);
      this.$emit("changeCursor", "default");
      this.$emit("save", this.object);
      this.show = false;
    },
    addBranch() {
      if (!this.object.tempDots[this.object.dot_index].dots) {
        this.$set(this.object.tempDots[this.object.dot_index], "dots", [
          {
            x: this.object.tempDots[this.object.dot_index].x + 30,
            y: this.object.tempDots[this.object.dot_index].y + 30,
          },
        ]);
      }
      this.$set(this.object, "show", false);
      this.$emit("changeCursor", "default");
      this.$emit("save", this.object);
      this.show = false;
    },
    removeBranch() {
      if (this.object.tempDots[this.object.dot_index].dots) {
        this.$delete(this.object.tempDots[this.object.dot_index], "dots");
      }
      this.$set(this.object, "show", false);
      this.$emit("changeCursor", "default");
      this.$emit("save", this.object);
      this.show = false;
    },
    changeCursor(cursor) {
      this.$emit("changeCursor", cursor);
    },
  },
};
</script>
